// extracted by mini-css-extract-plugin
export default {"custom-select":"PopupGetResult_custom-select__YPnWr","header-select":"PopupGetResult_header-select__KGv6p"};